import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import SelectedCourseList from './SelectedCourseList';
import CourseDropdown from './CourseDropdown';

import { formatCartItemDataFromPostData } from 'partials/modules/Courses';

import {
    addCartItem,
    removeCartItem,
    clearCart,
    setCartCollapsedValue,
    setBookingProgressCollapsedValue,
    updateCartItem
} from 'store';

const Wrapper = styled.div`
    width: 90%; 
    @media(max-width: 1000px){
        width: 100%; 
    }
`

const StyledSpan = styled.span`
    display: block;
    color: #fff;
    font-family: 'Source Sans Pro', sans-serif; 
    font-weight: 400;
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 25px;

    @media(max-width: 1000px){
        font-size: 22px;
        margin-top: 20px;
        margin-bottom: 5px; 
    }
`

class CourseSelector extends Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        let { cart, selectedCourses, courses } = this.props;

        if (cart.items.length > 0 && courses.length > 0 && cart.items.length > selectedCourses.length) {
            cart.items.map(item => {
                let obj = courses.find(course => course.value.id === item.post.id);

                if (!obj || selectedCourses.includes(obj)) {
                    return null;
                }

                selectedCourses.push(obj);
            })

            this.props.handleOptionChange(this.props.timeplanPeriod === 'Vår' ? 'Vår' : 'Høst');
            this.props.handleCourses(selectedCourses);
        }

        if (prevProps.cart.items.length > cart.items.length) {
            prevProps.cart.items.forEach(item => {
                if (!cart.items.includes(item)) {
                    let obj = courses.find(course => course.value.id === item.post.id);

                    if (!obj) {
                        return null;
                    }

                    this.removeCourse(obj, true);
                }
            })
        }

    }

    addCourse = (courseName, option = null) => {
        let { selectedCourses } = this.props;
        let obj = this.props.courses.find(course => course.name === courseName);

        if (!obj || selectedCourses.includes(obj)) {
            return null;
        }

        selectedCourses.push(obj);

        this.props.handleCourses(selectedCourses);
        this.props.handleOptionChange(obj.value.acf.period === "Vår" ? "Vår" : "Høst")

        const { addCartItem, setCartCollapsedValue, setBookingProgressCollapsedValue } = this.props;

        let options = this.props.cart.items.map(item => {
            return item.timeplan_option ? item.timeplan_option.id : null
        });

        options.push(obj.value.acf.options ? obj.value.acf.options[0].id : null);

        this.props.handleSelectedOptions(options);

        addCartItem(formatCartItemDataFromPostData(obj.value, option));
        setCartCollapsedValue(false);
        setBookingProgressCollapsedValue(true);
    }

    removeCourse = (toRemove, reduxUpdate = false) => {
        let filtered = this.props.selectedCourses.filter(course => course.value.id !== toRemove.value.id);

        this.props.handleCourses(filtered);
        this.props.handleOptionChange(filtered.length ? filtered[filtered.length - 1].value.acf.period === "Helår" ? "Høst" : filtered[filtered.length - 1].value.acf.period : "Høst")

        let cartItem = this.props.cart.items.find(course => course.post.id === toRemove.value.id);

        if (!reduxUpdate) {
            this.props.removeCartItem(cartItem);
        }
    }

    handleTermChange = (currentCourse, term) => {
        let { courses } = this.props;

        courses.forEach(course => {
            this.props.handleOptionChange(term === 'vår' ? 'Vår' : 'Høst');
            if (course !== currentCourse && course.name.split('(', 1)[0] === currentCourse.name.split('(', 1)[0]) {
                if (course.name.includes(term)) {
                    this.addCourse(course.name);
                    this.removeCourse(currentCourse);
                }
            }
        });
    }

    handleToggleOption = (options, option, course) => {
        this.props.handleSelectedOptions(options);

        if (option && course) {
            this.props.updateCartItem(formatCartItemDataFromPostData(course.value, option));
        }
    }

    render() {
        const { courses, selectedCourses, period, options, cart } = this.props;

        if (courses.length === 0) {
            return <div />;
        }

        return (
            <Wrapper>
                <StyledSpan>Dine alternativer</StyledSpan>
                <SelectedCourseList
                    courses={selectedCourses}
                    coursesInCart={cart.items}
                    allCourses={courses}
                    selectedCourses={selectedCourses}
                    period={period}
                    options={options}
                    handleToggleOption={this.handleToggleOption}
                    handleTermChange={this.handleTermChange}
                    removeCourse={this.removeCourse}
                    handleOptionChange={this.props.handleOptionChange}
                />
                <CourseDropdown
                    courses={courses}
                    addCourse={this.addCourse}
                />
            </Wrapper>
        )
    }
}

const mapStateToProps = (state) => {
    return Object.assign({
        cart: state.cart,
        timeplanPeriod: state.timeplanPeriod,
    });
};

const actions = {
    addCartItem,
    removeCartItem,
    clearCart,
    setCartCollapsedValue,
    setBookingProgressCollapsedValue,
    updateCartItem
}

export default connect(mapStateToProps, actions)(CourseSelector);


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/courseSelect/CourseSelector.js